import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { OtpService } from 'src/app/services/api/otp.service';
import { ErrorService } from 'src/app/services/error.service';
import { RestApiService } from 'src/app/services/rest-api.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-otp',
    templateUrl: './otp.component.html',
    styleUrls: ['./otp.component.scss']
})

export class OtpComponent implements OnInit {

    public title : string = "Medimail Patient - OTP";

    //@ts-ignore
    public otpForm : FormGroup;

    public errorMessage: string;
    public errorType: string;
    public ref: string;

    constructor(public userService: UserService,
                public route: Router,
                public activeRoute: ActivatedRoute,
                public otpApi: OtpService,
                public restApiService: RestApiService,
                private errorService: ErrorService,
                private titleService: Title)
    {
        this.errorMessage = "";
        this.errorType = "";
        this.ref = "";
        this.titleService.setTitle(this.title);
    }

    ngOnInit()
    {
        this.activeRoute.params.subscribe(params => {
            if (params.ref) {
                this.ref = params.ref;
            }
        });

        this.otpForm = new FormGroup({
            otpCode: new FormControl('', [Validators.required]),
        });

        if (!this.ref) {
          this.errorMessage="SUCCESS.OTP-SEND-PS"
        this.errorType = "SUCCESS";
            this.send();
        } else {
            this.sendPatient(this.ref);
        }
    }

    public send()
    {
        this.otpApi.askOtp(this.ref).subscribe(
            (res) => {
                if (res.result == 'ERROR') {
                    this.errorMessage = res.content;
                    this.errorType = res.result;
                }
            }, (resError) => {
                this.errorService.errorType = "ERROR";
                this.errorService.errorMessage = resError.error.detail;
                this.route.navigate(['/error']);
            }
        );
    }

    public sendPatient(ref: string)
    {
        this.restApiService.askOtp(this.ref).subscribe(
            (res) => {
                if (res.result == 'ERROR') {
                    this.errorMessage = res.content;
                    this.errorType = res.result;
                }
            }, (resError) => {
                this.errorService.errorType = "ERROR";
                this.errorService.errorMessage = resError.error.detail;
                this.route.navigate(['/error']);
            }
        );
    }

    public sendAgain()
    {
        if (!this.ref) {
            this.otpApi.askOtp(this.ref).subscribe(
                (res) => {
                    if (res.result == 'ERROR') {
                        this.errorMessage = res.content;
                        this.errorType = res.result;
                    } else {
                      this.errorMessage="SUCCESS.OTP-SEND-PS"
                      this.errorType = "SUCCESS";
                    }
                }, (resError) => {
                    this.errorService.errorType = "ERROR";
                    this.errorService.errorMessage = resError.error.detail;
                    this.route.navigate(['/error']);
                }
            );
        } else {
            this.restApiService.askOtp(this.ref).subscribe(
                (res) => {
                    if (res.result == 'ERROR') {
                        this.errorMessage = res.content;
                        this.errorType = res.result;
                    }
                }, (resError) => {
                    this.errorService.errorType = "ERROR";
                    this.errorService.errorMessage = resError.error.detail;
                    this.route.navigate(['/error']);
                }
            );
        }
    }

    public validateOtp = async (otpFormValue : any) =>
    {
        if (!this.ref) {
            await this.otpApi.checkOtp(otpFormValue.otpCode).then(
                (res) => {
                    if (res.result == "SUCCESS") {
                        if (this.userService.currentUser.cgu == true) {
                            this.route.navigate(['/cgu']);
                        } else {
                            this.route.navigate(['/folders', this.userService.currentUser.symfonyUser.defaultFolder]);
                        }
                    } else {
                        this.errorMessage = res.content;
                        this.errorType = res.result;
                    }
                }, (resError) => {
                    this.errorService.errorType = "ERROR";
                    this.errorService.errorMessage = resError.error.detail;
                    this.route.navigate(['/error']);
                }
            );
        } else {
            await this.restApiService.checkOtpPatient(this.ref, otpFormValue.otpCode).then(
                (res) => {
                    if (res.result == "SUCCESS") {
                        this.userService.currentUser.apiToken = res.content.apiToken;
                        this.userService.currentUser.refreshToken = res.content.refreshToken;
                        this.userService.currentUser.symfonyUser = res.content.user;
                        this.route.navigate(['open/client/message/', this.ref]);
                    } else {
                        this.errorMessage = res.content;
                        this.errorType = res.result;
                    }
                }, (resError) => {
                    this.errorService.errorType = "ERROR";
                    this.errorService.errorMessage = resError.error.detail;
                    this.route.navigate(['/error']);
                }
            );
        }
    }

    public hasError = (controlName: string, errorName: string) => {
        return this.otpForm.controls[controlName].dirty && this.otpForm.controls[controlName].hasError(errorName);
    }
}
